module.exports = __webpack_public_path__ + "static/media/push-notifications.4615c299.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/legacy-app/push-notifications.md
// module id = 389
// module chunks = 0